import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import i18n from '../../../../../i18next';
import { Container, Row, Button, Col, Form, Input, FormFeedback, Badge, UncontrolledTooltip } from 'reactstrap';
import Pagination from 'react-js-pagination';
import MaterialIcon from 'material-icons-react';

import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from '../../../../../utils/Constants';
import SearchButton from '../../../../common/SearchButton';
import { downloadInvoice, getInvoiceCollection, getInvoices, getMonthlyPayableReconciliation, downloadInvoices } from '../../../../../actions';
import { getCurrencySymbol, transformProductPrice } from '../../../../../utils/CommonUtils';
import AutoCompleteSearch from '../../../../central/autosearch/AutoCompleteSearch';

class BillingDashboardInvoiceCollection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchQuery: {
                restaurantId: '',
                week: '',
                year: '',
                billingType: '',
                brandId: ''
            },
            currentPageNumber: 0,
            isEmptyField: false,
            restaurantName: '',
            brandName: ''
        }
        this.search = this.search.bind(this);
        this.changeState = this.changeState.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleMonthlyPageChange = this.handleMonthlyPageChange.bind(this);
    }

    componentWillUnmount() {
        this.setState({
            searchQuery: {
                restaurantId: '',
                week: '',
                year: '',
                billingType: '',
                brandId: ''
            },
            currentPageNumber: 0,
            isEmptyField: false,
            restaurantName: '',
            brandName: ''
        })
    }   

    onKeyUp(event) {
        event.preventDefault();
        if (event.keyCode === 13) {
            document.getElementById('advanceSearchButton').click();
        }
    }

    search() {
        const { week, year } = this.props.invoiceCollectionDate;
        const { restaurantId, billingType, brandId } = this.state.searchQuery
        const { invoiceCollection, monthlyPayableRecon } = this.props;
        const billingTypeIndex = billingType === 'simpleBilling' ? 1 : billingType === 'advanceBilling' ? 2 : '';
        const { month } = this.props.monthlyPayableReconDate;
        const yearForMonthlyStats = this.props.monthlyPayableReconDate.year;
        
        if(invoiceCollection) {
            this.props.getInvoiceCollection(this.state.currentPageNumber, week, year, restaurantId, null, billingTypeIndex, brandId);
        } else if(monthlyPayableRecon) {
            this.props.getMonthlyPayableReconciliation(this.state.currentPageNumber, month, yearForMonthlyStats, restaurantId, billingTypeIndex);
        }
    }

    clearSearch() {
        const { week, year } = this.props.invoiceCollectionDate;
        const { invoiceCollection, monthlyPayableRecon } = this.props;
        const { month } = this.props.monthlyPayableReconDate;
        const yearForMonthlyStats = this.props.monthlyPayableReconDate.year;

        if (invoiceCollection) { 
            this.setState({
                ...this.state,
                searchQuery: {
                    ...this.state.searchQuery,
                   restaurantId: '',
                   billingType: ''
                },
                currentPageNumber: 0,
                isEmptyField: false,
                restaurantName: '',
                brandName: ''
            }, () => this.props.getInvoiceCollection(this.state.currentPageNumber, week, year));
        } else if (monthlyPayableRecon) {
            this.setState({
                ...this.state,
                searchQuery: {
                    ...this.state.searchQuery,
                   restaurantId: '',
                   billingType: ''
                },
                currentPageNumber: 0,
                isEmptyField: false,
                restaurantName: '',
                brandName: ''
            }, () => this.props.getMonthlyPayableReconciliation(this.state.currentPageNumber, month, yearForMonthlyStats));
        }
    }

    handlePageChange(pageNumber) {
        const { week, year } = this.props.invoiceCollectionDate;
        const { billingType } = this.state.searchQuery;
        const billingTypeIndex = billingType === 'simpleBilling' ? 1 : billingType === 'advanceBilling' ? 2 : '';

        this.setState({
            currentPageNumber: (pageNumber - 1)
        }, () => this.props.getInvoiceCollection(this.state.currentPageNumber, week, year, null, null, billingTypeIndex));
    }

    handleMonthlyPageChange(pageNumber) {
        const { month, year } = this.props.monthlyPayableReconDate;
        const { billingType } = this.state.searchQuery;
        const billingTypeIndex = billingType === 'simpleBilling' ? 1 : billingType === 'advanceBilling' ? 2 : '';

        this.setState({
            currentPageNumber: (pageNumber - 1)
        }, () => this.props.getMonthlyPayableReconciliation(this.state.currentPageNumber, month, year, null, billingTypeIndex));
    }

    changeState = (e, inputData, inputName) => {
        if (!e) {
            this.setState({
                ...this.state,
                currentPageNumber: 0,
                isEmptyField: false,
                searchQuery: {
                    ...this.state.searchQuery,
                    restaurantId: inputData.restaurantId
                },
                [inputName]: `${inputData['brandName']}, ${inputData['restaurantName']}`,
                [`${'restaurantName'}Data`]: inputData
            });

            return;
        } else if(e.target.name === 'brandName') {
            this.setState({
                currentPageNumber: 0,
                isEmptyField: true,
                searchQuery: {
                    ...this.state.searchQuery,
                    restaurantId: ''
                },
                brandName: e.target.value
            });

            return;
        }

        let targetValue = e.target.value;

        this.setState({
            currentPageNumber: 0,
            [e.target.name]: targetValue,
            searchQuery: {
                ...this.state.searchQuery,
                [e.target.name]: targetValue
            },
        });
    }

    onBack() {
        this.setState({
            searchQuery: {
                restaurantId: '',
                week: '',
                year: '',
                billingType: '',
                brandId: ''
            },
            currentPageNumber: 0,
            isEmptyField: false,
            restaurantName: '',
            brandName: ''
        }, () => this.props.onBackInvoiceCollection())
    }

    toggleBillingInvoiceInformation(billingInformationRow1, billingInformationRow2) {
        const table = document.querySelector(`.${billingInformationRow1}`)
        const icon = table.querySelector('i');
        const item = document.querySelector(`.${billingInformationRow2}`);

        if (![...table.classList].includes('activeBillingInformationRow')) {
            table.classList.add('activeBillingInformationRow');
            icon.textContent = 'do_not_disturb_on';
            item.style.display = 'block';
            table.style.borderBottom = '';
        } else {
            table.classList.remove('activeBillingInformationRow');
            icon.textContent = 'add_circle';
            item.style.display = 'none';
            table.style.borderBottom = '1px solid rgb(222, 226, 230)';
        }
    }
    

    renderDownloadButton = (restaurantId, week, month, year, index, rowIndex) => {
        const { invoiceCollection, monthlyPayableRecon } = this.props;

        return (
            <Fragment>
            {
                invoiceCollection ? 
                <Button onClick={() => this.props.downloadInvoice(restaurantId, week, null, year)} color="link" style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px' }}>
                        <MaterialIcon icon="cloud_download" color="#0288D1" size={19} />
                    </span>
                    {i18n.t('screens:eventTrackingScreen.download')}
                </Button> : 
                monthlyPayableRecon ?
                <Button id={`downloadWeeklyInvoice${rowIndex}${index}`} onClick={() => this.props.downloadInvoice(restaurantId, week, month, year)} color="link" style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px' }}>
                        <MaterialIcon icon="cloud_download" color="#0288D1" size={19} />
                    </span>
                    <UncontrolledTooltip placement="top" target={`downloadWeeklyInvoice${rowIndex}${index}`}>
                        {i18n.t('common:buttons.download')}
                    </UncontrolledTooltip>
                </Button> : null 
            }
            </Fragment>
        )
    }

    renderPagination() {
        const { flexEnd } = styles;
        const { invoiceCollection } = this.props;

        return (
            <Col style={flexEnd}>
                <Pagination
                    activePage={invoiceCollection ? invoiceCollection.number + 1 : null}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={invoiceCollection ? invoiceCollection.totalElements : null}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handlePageChange}
                />
            </Col>
        );
    }

    renderMonthlyPagination() {
        const { flexEnd } = styles;
        const { monthlyPayableRecon } = this.props;

        return (
            <Col style={flexEnd}>
                <Pagination
                    activePage={monthlyPayableRecon ? monthlyPayableRecon.number + 1 : null}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={monthlyPayableRecon ? monthlyPayableRecon.totalElements : null}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handleMonthlyPageChange}
                />
            </Col>
        );
    }

    renderHeader() {
        const { btnStyle } = styles
        const { invoiceCollection, monthlyPayableRecon } = this.props;
        const { week, year } = this.props.invoiceCollectionDate;
        const { month } = this.props.monthlyPayableReconDate;
        const yearForMonthlyStats = this.props.monthlyPayableReconDate.year;
        const collectionDate = invoiceCollection ? `${i18n.t('screens:paymentScreen.week')} ${week} / ${year}` : monthlyPayableRecon ? `${i18n.t('screens:paymentScreen.month')} ${month} / ${yearForMonthlyStats}` : null

        return (
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
                <Button onClick={() => this.onBack()} color="primary" style={{ display: 'flex', marginRight: '10px' }}>
                    <span style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="navigate_before" color="#fff" size={18} /></span>
                    <span style={btnStyle}>{i18n.t('common:buttons.back')}</span>
                </Button>
                <span style={{color: '#0288d1', fontSize: '20px'}}>{collectionDate}</span>
            </div>
        );
    }


    renderSearch() {
        const { restaurantNames } = this.props.ordersLog;
        const { searchQuery, brandName } = this.state;
        const { monthlyPayableReconDate } = this.props;

        return (
            <Col style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '20px' }} xs="auto" sm={12} >
                <Form id='advanceSearchForm' onKeyUp={this.onKeyUp}>
                    <Row style={{width: '800px'}}>
                        <Col>
                            <AutoCompleteSearch
                                inputId='brandName'
                                inputName='brandName'
                                placeholder={i18n.t('screens:brandsScreen.brandName')}
                                inputValue={brandName}
                                isEmptyField={this.state.isEmptyField}
                                inputStyle={{}}
                                changeState={this.changeState}
                                searchValues={restaurantNames}
                                isRestaurantNamesInBrand={true} />
                            <FormFeedback>{i18n.t('screens:eventTrackingScreen.errorMessage')}</FormFeedback>
                        </Col>
                        <Col style={{ maxWidth: 190, display: 'flex', flexDirection: 'column', padding: 0, marginLeft: '5px' }} >
                            <Input type="select" name="billingType" id="billingType" placeholder={i18n.t('screens:paymentScreen.billingType')} value={searchQuery.billingType} onChange={this.changeState}>
                                <option value=''>{i18n.t('screens:paymentScreen.billingType')}</option>
                                <option value="simpleBilling">{i18n.t('screens:paymentScreen.simpleBilling')}</option>
                                <option value="advanceBilling">{i18n.t('screens:paymentScreen.advancedBilling')}</option>
                            </Input>
                        </Col>
                        <Col style={{ maxWidth: 190, display: 'flex', alignItems: 'flex-end', flexDirection: 'column', padding: 0, marginLeft: '15px' }}>
                            <SearchButton search={this.search} />
                            <Button
                                color="link"
                                style={{ paddingTop: 0, paddingRight: 0, minWidth: 80, textAlign: 'right' }}
                                onClick={() => this.clearSearch()}
                                >
                                    {i18n.t('common:searchForms.clear')}
                            </Button>
                        </Col>
                    </Row>
                    <div style={{fontSize: '13px'}}>
                        {monthlyPayableReconDate.month ? i18n.t('screens:paymentScreen.additionalChargeMessage') : null}
                    </div>
                </Form>
            </Col>
        )
    }

    renderStatusRevenues (invoice, billingInformationRow1) {
        const { reportInfoStatusRevenue } = styles;
        const { statusRevenues, currency } = invoice;
        const invoiceCurrency = getCurrencySymbol(currency);
        const badgeWidth = '100px';
        
        if (statusRevenues !== undefined && statusRevenues !== null && statusRevenues.length) {
            return statusRevenues.map((statusRevenue, i) => {
                const statusRevenueHasSymbol = statusRevenue.status.includes("_");
                let statusRevenueItem;
                statusRevenueItem = statusRevenueHasSymbol ? statusRevenue.status.replace("_", " ") :  statusRevenue.status;

                return (
                <Col xs={12} style={{display: 'flex', paddingLeft: '0px', alignItems: 'center', marginBottom: '5px'}}>
                    <Col xs={3} style={reportInfoStatusRevenue}>
                        <span className='statusRevenueItem' style={{textAlign: 'justify', width: '87px'}}>{statusRevenueItem}:&nbsp;&nbsp;</span>
                        <span>
                            <Badge color="primary" style={{ fontSize: 12, minWidth: '80px' }}>&nbsp;{statusRevenue.count}&nbsp;</Badge> 
                        </span> 
                    </Col>
                    <Col xs={3} style={reportInfoStatusRevenue}>
                            <span className='statusRevenueItem' style={{display: 'flex'}}>
                                <span style={{display: 'flex', marginRight: '2px', marginLeft: '15px', alignItems: 'center'}} id={'infoIconBillingDashboard' + billingInformationRow1 + i}>
                                    <MaterialIcon icon='info' color="#0288D1" size={13} />
                                </span>
                                {i18n.t('screens:paymentScreen.total')}:&nbsp;&nbsp;
                            </span>
                            <span style={{display: 'flex'}}>
                                <Badge color="primary" style={{ fontSize: 12, minWidth: '80px' }}>
                                    &nbsp;{transformProductPrice(Number(statusRevenue.total))}
                                    <span>{invoiceCurrency}</span>
                                    &nbsp;
                                </Badge>&nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                            <UncontrolledTooltip placement="top" target={'infoIconBillingDashboard' + billingInformationRow1 + i} >
								{i18n.t('screens:paymentScreen.paidWithGiftCards')}{transformProductPrice(Number(statusRevenue.giftCardTotal))}
                                    <span>{invoiceCurrency}</span>
							</UncontrolledTooltip>
                    </Col>
                    <Col xs={3} style={reportInfoStatusRevenue}>
                            <span>{i18n.t('screens:paymentScreen.giftCardRefunded')}:&nbsp;&nbsp;</span>
                            <span style={{paddingBottom: '5px'}}><Badge color="primary" style={{ fontSize: 12, minWidth: '80px'}}>&nbsp;{transformProductPrice(Number(statusRevenue.giftCardRefundsTotal))}<span>{invoiceCurrency}</span>&nbsp;</Badge></span>
                    </Col>
                    <Col xs={3} style={reportInfoStatusRevenue}>
                            <span>{i18n.t('screens:paymentScreen.refunded')}:&nbsp;&nbsp;</span>
                            <span style={{paddingBottom: '5px'}}><Badge color="primary" style={{ fontSize: 12, minWidth: '80px'}}>&nbsp;{transformProductPrice(Number(statusRevenue.refundsTotal))}<span>{invoiceCurrency}</span>&nbsp;</Badge></span>
                    </Col>
                </Col>
                )
            })
        }
    }

    renderBillingStatistics(title1, item1, title2, item2, currency) {
        const { reportInfoContainer, reportInfo } = styles;

        return (
            <Col style={reportInfoContainer} className='billingStatistics'> 
                {title1 ?
                <Col xs={6} style={reportInfo}>
                    <span className='billingInformationItem'>{i18n.t(`${title1}`)}:&nbsp;&nbsp;</span>
                    <span><Badge color="primary" style={{ fontSize: 12, minWidth: '80px' }}>&nbsp;{`${item1}`}&nbsp;</Badge>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </Col> : <Col xs={6} style={reportInfo}><span className='billingInformationItem'></span></Col>}
                <Col xs={5} style={reportInfo}>
                    <span>{i18n.t(`${title2}`)}:&nbsp;&nbsp;</span>
                    <span><Badge color="primary" style={{ fontSize: 12, minWidth: '80px' }}>&nbsp;{transformProductPrice(Number(`${item2}`))}<span>{getCurrencySymbol(currency)}</span>&nbsp;</Badge></span>
                </Col>
        </Col>
        )
    }

    renderBillingInvoiceInformation(invoice, billingInformationRow1) {
        const {successfulSales, currency} = invoice;

        return (
            <Row xs={12} style={{width: "100%"}}>
                <Col xs={6} className='billingStatisticsColumn1' style={{marginBottom: '5px', paddingRight: '0px', borderRight: '1px solid #dee2e6'}}>
                    {this.renderBillingStatistics('screens:paymentScreen.refundCount', invoice.refundsCount, 'screens:paymentScreen.refundTotal', invoice.refundsTotal, currency)}
                    {this.renderBillingStatistics('screens:paymentScreen.giftCardRefundCount', invoice.giftCardRefundsCount, 'screens:paymentScreen.giftCardRefundTotal', invoice.giftCardRefundTotal, currency)}
                    {this.renderBillingStatistics('screens:paymentScreen.succesfulOrderCount', successfulSales.orderCount, 'screens:paymentScreen.successfulOrderTotal', successfulSales.orderTotal, currency)}
                    {this.renderBillingStatistics('screens:paymentScreen.successfulCashOrderCount', successfulSales.cashOrderCount, 'screens:paymentScreen.successfulCashOrderTotal', successfulSales.cashOrderTotal, currency)}
                    {this.renderBillingStatistics('screens:paymentScreen.successFulCardOrderCount', successfulSales.cardOrderCount, 'screens:paymentScreen.successFulCardOrderTotal', successfulSales.cardOrderTotal, currency)}
                    {this.renderBillingStatistics(null, null, 'screens:paymentScreen.successfulGiftCardOrderTotal', successfulSales.giftCardOrderTotal, currency)}
                </Col>
                <Col xs={6} style={{width: '100%', left: '2%', paddingLeft: '0px'}} className='billingStatisticsColumn2'>
                    {this.renderStatusRevenues(invoice, billingInformationRow1)}
                </Col>
            </Row>
        );
    }

    renderOrderTotalIndicator(index, movementIndex, totalMovementPercent) {
        if(movementIndex === 1) {
            return (
                <span id={`positiveIndicator${index}`} style={{position: 'absolute'}}>
                    <MaterialIcon icon='north' color="green" size={17}/>
                    <UncontrolledTooltip placement="top" target={`positiveIndicator${index}`} >
								{`${totalMovementPercent}%`}
					</UncontrolledTooltip>
                </span>
            )
        } else if(movementIndex === -1) {
            return (
                <span id={`negativeIndicator${index}`} style={{position: 'absolute'}}>
                    <MaterialIcon icon='south' color="red" size={17}/>
                    <UncontrolledTooltip placement="top" target={`negativeIndicator${index}`} >
								{`${totalMovementPercent}%`}
					</UncontrolledTooltip>
                </span>
            )
        }
    }

    renderTable() {
        const { invoiceCollection, monthlyPayableRecon } = this.props;
        const { headerContainer } = styles

        return (
            <Col style={{ padding: '0px' }}>
                {
                invoiceCollection ?
                <Row style={{...headerContainer, backgroundColor: '#f8f8f8', padding: '10px 0', borderBottom: 'none'}}>
                
                    <Col xs={2}>{i18n.t('screens:paymentScreen.restaurant')}</Col>
                    <Col xs={1}>
                        <span>
                            {i18n.t('screens:paymentScreen.billingType')}
                        </span>
                        <span style={{ marginLeft: '2px', position: 'absolute'}} id='billingTypeInfo'>
                            <MaterialIcon icon='info' color="#0288D1" size={17}/>
                        </span>
                        <UncontrolledTooltip placement="top" target={'billingTypeInfo'} >
								{i18n.t('screens:paymentScreen.billingTypeInfo')}
						</UncontrolledTooltip>
                    </Col>
                    <Col xs={1}>{i18n.t('screens:paymentScreen.count')}</Col>
                    <Col xs={1}>{i18n.t('screens:paymentScreen.orderTotal')}</Col>
                    <Col xs={1}>{i18n.t('screens:paymentScreen.cashTotal')}</Col>
                    <Col xs={1}>{i18n.t('screens:paymentScreen.cardTotal')}</Col>
                    <Col xs={1}>{i18n.t('screens:paymentScreen.giftCardTotal')}</Col> 
                    <Col xs={2}>{i18n.t('screens:paymentScreen.averageOrder')}</Col>
                    <Col xs={1}>{i18n.t('screens:paymentScreen.invoice')}</Col> 
                </Row> : 
                monthlyPayableRecon ? 
                    <Row style={{...headerContainer, backgroundColor: '#f8f8f8', padding: '10px 0', borderBottom: 'none', justifyContent: 'space-between'}}>
                        <Col xs={2}>{i18n.t('screens:restaurantsScreen.location')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.billingType')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.paidToClient')}</Col> 
                        <Col xs={2}>{i18n.t('screens:paymentScreen.paidByClient')}</Col>
                        <Col xs={2}>{i18n.t('screens:paymentScreen.invoices')}</Col>
                    </Row> : null 
                }
                {
                    invoiceCollection ?
                        this.renderTableRows() :
                    monthlyPayableRecon ? 
                        this.renderMonthlyTableRows() :
                        <Col style={{ width: '90%', padding: '15px 15px 0', borderBottom: '1px solid #dee2e6' }}>
                            <p style={{ fontSize: '14px' }}>{i18n.t('screens:centralOrdersLog.noResults')}</p>
                        </Col>
                }
                <Col style={{ paddingRight: '0px' }}>{invoiceCollection ? this.renderPagination() : this.renderMonthlyPagination()}</Col>
            </Col>
        );
    }

    renderTableRows() {
        const { headerContainer, billingInvoiceInformationButtonStyle, headerContainerNoBorder } = styles;
        const { invoiceCollection } = this.props;
        const content = invoiceCollection.content ? invoiceCollection.content : null;

        if (content !== undefined && content !== null && content.length) {
            return content.map((invoice, i) => {

                const billingInformationRow1 = `billingInformationRow1${i}`;
                const billingInformationRow2 = `billingInformationRow2${i}`;

                return (
                    <div>
                    <Row style={headerContainer} className={billingInformationRow1}>
                        <Col xs={2} style={{display: 'flex', alignItems: 'center'}}>
                            <Button xs={1}  onClick={() => this.toggleBillingInvoiceInformation(billingInformationRow1, billingInformationRow2)} outline="false" style={billingInvoiceInformationButtonStyle}>
                                <MaterialIcon icon='add_circle' color="#0288D1" size={19} style={{paddingLeft: '0px'}}/>
                            </Button>
                            <Col xs={10}>{invoice.location}</Col>
                        </Col>
                        <Col xs={1}>{invoice.billingTypeName}</Col>
                        <Col xs={1}>{Number(invoice.allSales.orderCount)}</Col>
                        <Col xs={1}><span>{transformProductPrice(Number(invoice.allSales.orderTotal))}</span><span> {getCurrencySymbol(invoice.currency)}</span>{this.renderOrderTotalIndicator(i, invoice.movementIndex, invoice.totalMovementPercent)}</Col>
                        <Col xs={1}><span>{transformProductPrice(Number(invoice.allSales.cashOrderTotal))}</span><span> {getCurrencySymbol(invoice.currency)}</span></Col>
                        <Col xs={1}><span>{transformProductPrice(Number(invoice.allSales.cardOrderTotal))}</span><span> {getCurrencySymbol(invoice.currency)}</span></Col>
                        <Col xs={1}><span>{transformProductPrice(Number(invoice.allSales.giftCardOrderTotal))}</span><span> {getCurrencySymbol(invoice.currency)}</span></Col>
                        <Col xs={2}><span>{transformProductPrice(Number(invoice.averageOrder))}</span><span> {getCurrencySymbol(invoice.currency)}</span></Col>
                        <Col xs={1} style={{ display: 'flex', justifyContent: 'center' }}>{this.renderDownloadButton(invoice.restaurantId, invoice.week, null, invoice.year)}</Col>
                    </Row>
                    <Row style={{display: 'none',  borderBottom: '1px solid #dee2e6', margin: '0px'}} className={billingInformationRow2}>
                        {this.renderBillingInvoiceInformation(invoice, billingInformationRow1)}
                    </Row>
                    </div>
                )
            })
        }
    }
    
    renderMonthlyBillingStatistics(title1, item1, currency) {
        const { reportMonthlyInfoContainer } = styles;
        
        return (
            <div className={title1 === 'screens:paymentScreen.week' || title1 === 'screens:paymentScreen.month' ? 'monthlyBillingInformationRow' : ''} style={{...reportMonthlyInfoContainer, marginLeft: title1 === 'screens:paymentScreen.week' || title1 === 'screens:paymentScreen.month' ? '30px' : '0'}}>
                <span style={{ textAlign: 'center' }}>{i18n.t(`${title1}`)}:&nbsp;&nbsp;</span>
                <span><Badge color="primary" style={{ fontSize: 12, minWidth: '80px', position: 'inherit' }}>&nbsp;{`${item1}`}&nbsp;<span>{title1 === 'screens:paymentScreen.week' || title1 === 'screens:paymentScreen.month' ? null : getCurrencySymbol(currency)}</span></Badge>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            </div>
        )
    }

    renderIncludedMonthlyInvoices(invoice, rowIndex) {
        const { currency } = invoice;
        const content = invoice.includedInvoices ? invoice.includedInvoices : null;
        const restaurantId = invoice.restaurantId;

        if (content !== undefined && content !== null && content.length) {
            return content.map((invoice, i) => {
                const weekOrMonthTitle = invoice.week ? 'screens:paymentScreen.week' : 'screens:paymentScreen.month';
                const weekOrMonthContent = invoice.week ? invoice.week : invoice.month;
                    return (
                        <Row key={i} xs={12} style={{width: "100%", margin: '0', padding: '0', paddingRight: '20px', position: 'relative'}}>
                            <Col xs={2} style={{paddingLeft: 0}}>{this.renderMonthlyBillingStatistics(weekOrMonthTitle, weekOrMonthContent)}</Col>
                            <Col xs={2}>{this.renderMonthlyBillingStatistics('screens:paymentScreen.subscriptionTotal', transformProductPrice(Number(invoice.subscriptionTotal)), currency)}</Col>
                            <Col xs={2}>{this.renderMonthlyBillingStatistics('screens:paymentScreen.subscriptionTax', transformProductPrice(Number(invoice.subscriptionTax)), currency)}</Col>
                            <Col xs={2}>{this.renderMonthlyBillingStatistics('screens:paymentScreen.recurringChargesTotal', transformProductPrice(Number(invoice.recurringChargesTotal)), currency)}</Col>
                            <Col xs={2}>{this.renderMonthlyBillingStatistics('screens:paymentScreen.recurringChargesTax', transformProductPrice(Number(invoice.recurringChargesTax)), currency)}</Col>
                            <Col xs={2}>{this.renderMonthlyBillingStatistics('screens:paymentScreen.additionalChargesTotal', transformProductPrice(Number(invoice.additionalChargesTotal)), currency)}</Col>
                            <div style={{position: 'absolute', right: 0, top: '-9px'}}>{this.renderDownloadButton(restaurantId, invoice.week, invoice.month, invoice.year, i, rowIndex)}</div>
                        </Row>
                    );
            })
        }
    }

    renderMonthlyTableRows() {
        const { headerContainer, billingInvoiceInformationButtonStyle } = styles;
        const { monthlyPayableRecon } = this.props;
        const content = monthlyPayableRecon.content ? monthlyPayableRecon.content : null;

        if (content !== undefined && content !== null && content.length) {
            return content.map((invoice, i) => {

            const billingMonthlyInformationRow1 = `billingMonthlyInformationRow1${i}`;
            const billingMonthlyInformationRow2 = `billingMonthlyInformationRow2${i}`;
                return (
                    <div>
                    <Row style={{...headerContainer, justifyContent: 'space-between'}} className={billingMonthlyInformationRow1}>
                        <Col xs={2} style={{display: 'flex', alignItems: 'center'}}>
                            <Button xs={1}  onClick={() => this.toggleBillingInvoiceInformation(billingMonthlyInformationRow1, billingMonthlyInformationRow2)} outline="false" style={billingInvoiceInformationButtonStyle}>
                                <MaterialIcon icon='add_circle' color="#0288D1" size={19} style={{paddingLeft: '0px'}}/>
                            </Button>
                            <Col xs={10}>{invoice.location}</Col>
                        </Col>
                        <Col xs={2}>{invoice.billingTypeName}</Col>
                        <Col xs={2}><span>{transformProductPrice(Number(invoice.paidToClient))}</span><span> {getCurrencySymbol(invoice.currency)}</span></Col>
                        <Col xs={2}><span>{transformProductPrice(Number(invoice.paidByClient))}</span><span> {getCurrencySymbol(invoice.currency)}</span></Col>
                        <Col xs={2} style={{display: 'flex', justifyContent: 'center'}}>
                            <Button onClick={() => this.props.downloadInvoices(invoice.restaurantId, invoice.billingMonth, invoice.year)} color="link" style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ marginRight: '5px' }}>
                                    <MaterialIcon icon="cloud_download" color="#0288D1" size={19} />
                                </span>
                                {i18n.t('screens:eventTrackingScreen.download')}
                            </Button>
                        </Col>
                    </Row>
                    <Row style={{display: 'none',  borderBottom: '1px solid #dee2e6', margin: '0', paddingBottom: '10px' }} className={billingMonthlyInformationRow2}>
                        {this.renderIncludedMonthlyInvoices(invoice, billingMonthlyInformationRow2)}
                    </Row>
                    </div>
                )
            })
        }
    }

    render() {
        
        return (
            <div>
                <Row>{this.renderHeader()}</Row>
                <Row>{this.renderSearch()}</Row>
                <Row>{this.renderTable()}</Row>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        restaurant: state.restaurant
    }
};

export default connect(mapStateToProps, {downloadInvoice, getInvoiceCollection, getMonthlyPayableReconciliation, downloadInvoices})(BillingDashboardInvoiceCollection);

let styles = {
    headerContainer: {
        width: '100%',
        margin: 0,
        display: 'flex',
        justifyContent: 'space-around',
        textAlign: 'center',
        alignItems: 'center',
        padding: '5px 0',
        borderBottom: '1px solid #dee2e6'
    },
    headerContainerNoBorder: {
        width: '100%',
        margin: 0,
        display: 'flex',
        justifyContent: 'space-around',
        textAlign: 'center',
        alignItems: 'center',
        padding: '5px 0'
    },
    headerContainerTreeView: {
        width: '100%',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        padding: '5px 0',
    },
    paddingLeftRight: {
        maxWidth: '250px',
        paddingLeft: 5,
        paddingRight: 0,
        marginBottom: 5
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '30px',
        paddingRight: 0
    },
    btnStyle: {
        display: 'flex',
        alignSelf: 'center',
        padding: '0px 6px 3px'
    },
    billingInvoiceInformationButtonStyle: {
        backgroundColor: 'white', 
        border: 'none', 
        paddingRight: '0px',
        boxShadow: 'none'
    },
    reportInfoContainer: {
        width: '100%',
        // marginBottom: 30,
        display: 'flex',
        justifyContent: 'flex-start',
        left: '2.2em'
    },
    reportInfo: {
        padding: 5,
        fontSize: 14,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    reportInfoStatusRevenue: {
        padding: 5,
        fontSize: 14,
        display: 'flex',
        justifyContent: 'center',
        padding: '0 7px',
        lineHeight: '20px',
        alignItems: 'center',
        right: '1%'
    },
    reportMonthlyInfoContainer: {
        width: '100%',
        display: 'flex',
        padding: 5,
        fontSize: 14
    },
    reportMonthlyInfo: {
        padding: 5,
        fontSize: 14,
        display: 'flex',
        alignItems: 'center'
    },
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/menuuBilling/BillingDashboardInvoiceCollection.js